<div mat-dialog-title class="dialog-popup-header" style="display: flex; justify-content: space-between;">
    <h4 >Add Immunization</h4>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content style="padding: 0px 15px !important;">
    <div style="padding: 10px;">
        <h5>Immunization type <span style="color:red;">*</span></h5>

        <mat-form-field appearance="outline" style="width: 100%;max-width: 100%;">
            <mat-label>Select</mat-label>
            <mat-select [(ngModel)]="selectedImmunizationTypes" multiple>
                <mat-option *ngFor="let immunization of immunizations" [value]="immunization">
                    {{ immunization.petImmunizationTypeName }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- <mat-checkbox [(ngModel)]="sameDate" (ngModelChange)="onCheckBoxChange()">Same Date</mat-checkbox>
        <div style="margin-left:10px;"></div> -->
        <mat-checkbox [(ngModel)]="sameDocument" (ngModelChange)="onCheckBoxChange()">Same Document</mat-checkbox>

        <ng-container *ngIf="sameDocument">
            <div style="display:flex; justify-content: space-between; align-items: center;">
                <h5>Upload document</h5>

                <button mat-icon-button (click)="open()">
                    <mat-icon>file_upload</mat-icon>
                </button>
            </div>

            <p *ngIf="file">{{ file.name }}</p>

            <h5>Notes</h5>

            <mat-form-field appearance="outline" style="width: 100%;">
                <textarea matInput placeholder="Enter Notes" [(ngModel)]="notes"></textarea>
            </mat-form-field>
        </ng-container>
        
        <ng-container *ngIf="!sameDocument">
            <ng-container *ngFor="let immunization of selectedImmunizationTypes">
                <div style="display:flex; justify-content: space-between; align-items: center;">
                    <h5>Upload document for {{ immunization.petImmunizationTypeName }}</h5>

                    <button mat-icon-button (click)="openNew(immunization)">
                        <mat-icon>file_upload</mat-icon>
                    </button>
                </div>

                <p *ngIf="immunization.file">{{ immunization.file.name }}</p>

                <h5>Notes</h5>

                <mat-form-field appearance="outline" style="width: 100%;">
                    <textarea matInput placeholder="Enter Notes" [(ngModel)]="immunization.notes"></textarea>
                </mat-form-field>
            </ng-container>
        </ng-container>

        <input #uploadInput type="file" accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.heic,application/pdf" style="visibility: hidden;" (change)="onChange($event.target.files)" />
    </div>
</mat-dialog-content>

<mat-dialog-actions style="padding:10px;float:right; margin-bottom: 0px;">
    <mat-spinner *ngIf="isLoading" style="top: -185px;left: -40px;"></mat-spinner>
    <button mat-button mat-dialog-close mat-button style="background-color:#ff0000;color: white;">Cancel</button>
    <button mat-button [disabled]="btnDisabled" style="background-color:#41A049;color: white;" (click)="addImmunization()">Save</button>
</mat-dialog-actions>
